export const faqs = [
  {
    id: "faq1",
    question: "第一次做某件事时，感到紧张是正常的吗？",
    answer: "完全正常！紧张是人类面对未知和新体验时的自然生理反应。适度的紧张甚至能提升你的专注力和表现水平。关键不是消除紧张，而是学会与它共处，将它转化为积极的动力。记住，每个人在面对「第一次」时都会有类似的感受，你并不孤单。",
  },
  {
    id: "faq2",
    question: "如何区分正常的紧张和需要专业帮助的焦虑？",
    answer: "正常的紧张通常局限于特定情境，事情过后会自然消退。但如果焦虑持续超过两周，严重影响到日常生活（如持续的失眠、食欲下降、逃避社交），建议寻求心理咨询师的帮助。重视自己的心理健康是一种勇敢，而不是软弱。",
  },
  {
    id: "faq3",
    question: "第一次尝试失败了怎么办？",
    answer: "「第一次」本来就不是为了完美而存在的。每一个「第一次」的核心价值在于：你走出了舒适区，获得了宝贵的经验。失败是最好的老师——它告诉你哪里需要改进，下次如何做得更好。托马斯·爱迪生发明电灯之前失败了上千次，他说：「我没有失败，我只是找到了一千种不成功的方法。」",
  },
  {
    id: "faq4",
    question: "如何为即将到来的「第一次」做最充分的准备？",
    answer: "根据我们总结的「3P法则」：<strong>Plan（计划）</strong>- 提前了解相关信息，制定具体的行动步骤；<strong>Practice（练习）</strong>- 在脑海中预演或在实际环境中模拟，降低未知感；<strong>Perspective（视角）</strong>- 把「第一次」看作一次学习和体验的机会，而不是一次只能成功不能失败的考试。三个维度同时准备，效果最佳。",
  },
  {
    id: "faq5",
    question: "我们的文章内容是如何确保专业性的？",
    answer: "每一篇文章都由具有相关领域背景的编辑团队精心撰写，并经过多位审稿人的交叉审核。我们引用的心理学知识基于公认的学术理论（如耶克斯-多德森定律、聚光灯效应等），实践技巧来自真实经验者的分享和专业从业者的建议。我们致力于为读者提供既科学又实用的内容。",
  },
  {
    id: "faq6",
    question: "如果我在网站找不到我想了解的「第一次」主题怎么办？",
    answer: "我们的内容库正在持续扩展中。如果你有特别想了解的主题，可以通过「关于我们」页面的联系表单告诉我们。编辑团队会认真对待每一个建议，并优先纳入选题计划。你的每一次反馈，都在帮助这个平台变得更好。",
  },
];